var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mail-thread-container", style: { width: "100%" } },
    [
      _c("thread-header", {
        attrs: {
          "ref-visitor-id": _vm.thread.refVisitor,
          subject: _vm.thread.subject,
          threadMails: _vm.threadMails,
        },
        on: {
          "delete-thread": _vm.handleDeleteThread,
          close: function ($event) {
            return _vm.$emit("close")
          },
          reply: _vm.handleHeaderReply,
          "reply-all": _vm.handleHeaderReplyAll,
          forward: _vm.handleHeaderForward,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "scrollContainer", staticClass: "scrollable-container" },
        [
          _c(
            "div",
            { staticClass: "thread-messages" },
            [
              !_vm.threadMails.length
                ? _c("div", { staticClass: "loading-thread" }, [
                    _c("p", [_vm._v("Mail thread içeriği yükleniyor...")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.threadMails.length > 0
                ? _c(
                    "div",
                    { staticClass: "message-container" },
                    [
                      _c("thread-message", {
                        key: _vm.threadMails[0]._id,
                        attrs: {
                          mail: _vm.threadMails[0],
                          defaultExpanded: _vm.threadMails.length === 1,
                          threadShowsComposeForm:
                            _vm.showReply &&
                            _vm.selectedMailId === _vm.threadMails[0]._id,
                        },
                        on: {
                          reply: _vm.handleReply,
                          forward: _vm.handleForward,
                          delete: _vm.handleDelete,
                          "open-compose": _vm.handleMessageOpenCompose,
                        },
                      }),
                      _vm._v(" "),
                      _vm.showReply &&
                      _vm.selectedMailId === _vm.threadMails[0]._id
                        ? _c("mail-compose", {
                            staticClass: "reply-compose-form",
                            attrs: {
                              mailData: _vm.replyMailData,
                              isReply: !_vm.isForward,
                              isForward: _vm.isForward,
                              showHeader: false,
                              "selected-email-id": _vm.selectedEmailId,
                              threadMails: _vm.threadMails,
                            },
                            on: {
                              close: _vm.closeReplyForm,
                              sent: _vm.handleSent,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.threadMails.length > 2 && !_vm.showAllMessages
                ? _c(
                    "div",
                    {
                      staticClass: "collapsed-messages",
                      on: { click: _vm.expandAllMessages },
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "collapsed-messages-text" }, [
                        _vm._v(
                          _vm._s(_vm.threadMails.length - 2) +
                            " adet daha mail göster..."
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAllMessages && _vm.threadMails.length > 2
                ? _vm._l(
                    _vm.threadMails.slice(1, _vm.threadMails.length - 1),
                    function (mail) {
                      return _c(
                        "div",
                        { key: mail._id, staticClass: "message-container" },
                        [
                          _c("thread-message", {
                            attrs: {
                              mail: mail,
                              defaultExpanded: false,
                              threadShowsComposeForm:
                                _vm.showReply &&
                                _vm.selectedMailId === mail._id,
                            },
                            on: {
                              reply: _vm.handleReply,
                              forward: _vm.handleForward,
                              delete: _vm.handleDelete,
                              "open-compose": _vm.handleMessageOpenCompose,
                            },
                          }),
                          _vm._v(" "),
                          _vm.showReply && _vm.selectedMailId === mail._id
                            ? _c("mail-compose", {
                                staticClass: "reply-compose-form",
                                attrs: {
                                  mailData: _vm.replyMailData,
                                  isReply: !_vm.isForward,
                                  isForward: _vm.isForward,
                                  showHeader: false,
                                  threadMails: _vm.threadMails,
                                  "selected-email-id": _vm.selectedEmailId,
                                },
                                on: {
                                  close: _vm.closeReplyForm,
                                  sent: _vm.handleSent,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.threadMails.length > 1
                ? _c(
                    "div",
                    { staticClass: "message-container" },
                    [
                      _c("thread-message", {
                        key: _vm.threadMails[_vm.threadMails.length - 1]._id,
                        attrs: {
                          mail: _vm.threadMails[_vm.threadMails.length - 1],
                          defaultExpanded: true,
                          threadShowsComposeForm:
                            _vm.showReply &&
                            _vm.selectedMailId ===
                              _vm.threadMails[_vm.threadMails.length - 1]._id,
                        },
                        on: {
                          reply: _vm.handleReply,
                          forward: _vm.handleForward,
                          delete: _vm.handleDelete,
                          "open-compose": _vm.handleMessageOpenCompose,
                        },
                      }),
                      _vm._v(" "),
                      _vm.showReply &&
                      _vm.selectedMailId ===
                        _vm.threadMails[_vm.threadMails.length - 1]._id
                        ? _c("mail-compose", {
                            staticClass: "reply-compose-form",
                            attrs: {
                              mailData: _vm.replyMailData,
                              isReply: !_vm.isForward,
                              isForward: _vm.isForward,
                              showHeader: false,
                              threadMails: _vm.threadMails,
                              "selected-email-id": _vm.selectedEmailId,
                            },
                            on: {
                              close: _vm.closeReplyForm,
                              sent: _vm.handleSent,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.threadMails.length > 0 && !_vm.showReply
                ? _c("div", { staticClass: "thread-footer-actions" }, [
                    _c(
                      "div",
                      { staticClass: "action-buttons" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            staticClass: "action-btn",
                            attrs: { icon: "reply", primary: "" },
                            on: {
                              click: function ($event) {
                                return _vm.handleReply(
                                  _vm.threadMails[_vm.threadMails.length - 1]
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Yanıtla\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.hasMultipleRecipients(
                          _vm.threadMails[_vm.threadMails.length - 1]
                        )
                          ? _c(
                              "SupsisButton",
                              {
                                staticClass: "action-btn",
                                attrs: { icon: "reply_all", primary: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReplyAll(
                                      _vm.threadMails[
                                        _vm.threadMails.length - 1
                                      ]
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Tümünü Yanıtla\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "SupsisButton",
                          {
                            staticClass: "action-btn",
                            attrs: { icon: "forward", primary: "" },
                            on: {
                              click: function ($event) {
                                return _vm.handleForward(
                                  _vm.threadMails[_vm.threadMails.length - 1]
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Yönlendir\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "collapsed-messages-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("expand_more")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }